export default __webpack_public_path__ + "static/media/Vector (1).04722274.svg";